import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';

export const DivStyledClaimsInfoModule = styled.div`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const thisHorizontalPadding = mediumUp ? rem(10) : rem(18);
    const thisVerticalPadding = mediumUp ? rem(48) : rem(32);
    return css`
      background-color: ${theme.colors.neutral.grayLight2};
      padding: ${thisVerticalPadding} ${thisHorizontalPadding};
      display: flex;
      flex-direction: column;
      flex: 1;
    `;
  }
}`;

export const DivStyledVideoContainer = styled.div`
 ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      position: relative;
      height: 0;
      padding-bottom: 56.25%;
      margin-bottom: ${mediumUp ? rem(40) : rem(32)};
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `;
  }
}`;

export const LinkStyled = styled(Link)`
  display: block;
  padding-bottom: ${rem(24)};
`;

export const LinkStyledButton = styled(Link)`
  margin-bottom: ${rem(24)};
`;
